import Logo from "./Logo";

const letters = ["E", "L", "I", "T", "E", "S", "O", "F", "T"];

const Preloader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-canvas gap-6">
      <Logo variant="dark" width={200} />
      <div className="flex gap-0.5 text-brand/80 font-light text-2xl tracking-[0.3em]">
        {letters.map((ch, i) => (
          <span
            key={i}
            className="inline-block animate-wavy"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            {ch}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Preloader;
